import {connect} from "react-redux";
import {DispatchProps, Home, InnerProps, StateProps} from "../components/Home";
import {RootState, ThunkDispatch} from "../types";

function mapStateToProps(): StateProps {
    return {
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(Home);
